// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2J4Jk","productName":"Table_productName__3GOpd"};